import React from 'react';
import './c38_faq_accordion.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {insertHtml} from "../../utils/dom";

class AccordionFAQ extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            block1: false,
            block2: false
        };
    }

    toggle = (index) => () => {
        this.setState({[`block${index}`]: !this.state[`block${index}`]});
    };

    componentRender(data) {
        return (
            <div className="c38-faq auto-margins">
                <div className="container-fluid accordion-container">
                    <div className="row accordion-row">
                        <div className="col accordion">
                            {data.faq && data.faq.map((qnA, index) => (
                                <div key={index} className="accordion-section">
                                    <dt className={(this.state[`block${index + 1}`]) ? 'title is-expanded' : 'title'}
                                        onClick={this.toggle(index + 1)}>{qnA.question}</dt>
                                    <dd className={(this.state[`block${index + 1}`]) ? 'content is-expanded' : 'content'}
                                        onClick={this.toggle(index + 1)}>
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="col">
                                                    <div className="table-row" {...insertHtml(qnA.answer)} />
                                                </div>
                                            </div>
                                        </div>
                                    </dd>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AccordionFAQ;

